import { useLang } from "@/i18n";

export default function Marquee() {
    const { t } = useLang();
    return (
        <div className="grain relative overflow-hidden bg-ink py-3.5 text-white" aria-label="Our services">
            <div className="animate-marquee flex w-max">
                {[0, 1].map((k) => (
                    <div key={k} aria-hidden={k === 1} className="flex items-center">
                        {t.marquee.map((item, i) => (
                            <span
                                key={i}
                                className="flex items-center gap-6 pe-6 text-xs font-semibold uppercase tracking-[0.18em] sm:text-sm"
                            >
                                {item}
                                <span className="inline-block h-1.5 w-1.5 rotate-45 bg-gold" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
